import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Slice = styled.div`
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  opacity: 0;
  z-index: 5000;
`;

export const InputHeader = styled.div``;

export const InputContainer = styled.div``;

export const RadioBtn = styled.button`
  cursor: pointer;
  background-color: inherit;
  padding: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid ${Palette.PrimaryGray._400};
  margin-left: 10px;
  border: ${({ isActive }) => isActive && `6px solid ${Palette.Primary._500}`};
`;

const highlightStyle = css`
  & strong {
    color: ${Palette.Primary._500};
    font-weight: inherit;
  }
`;

export const ListItem = styled.li`
  z-index: 6000;
  display: flex;
  align-items: center;
  gap: 16px;
  list-style: none;
  margin-right: 5px;
  cursor: pointer;
  &:hover {
    border-radius: 4px;
    background: ${() => Palette.PrimaryGray._100};
    ${RadioBtn} {
      border: 6px solid ${Palette.Primary._500};
    }
  }
  &:active {
    border-radius: 4px;
    background: ${() => Palette.Primary._000};
  }

  ${highlightStyle}
  padding: 7px 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;

export const DropDownList = styled.ul`
  padding-left: 14px;
  padding-right: 2px;
  max-height: 240px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${() => Palette.PrimaryGray._300};
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff;
  }
`;

export const ComponentForScroll = styled.div`
  z-index: 6000;
  background: white;
  padding: 5px 5px 5px 0;
  box-shadow: 0px 16px 24px rgba(23, 43, 77, 0.04), 0px 16px 32px rgba(23, 43, 77, 0.08);
  border-radius: 8px;
  border: 1px solid ${Palette.PrimaryGray._200};
  overflow: hidden;
`;

export const LoaderWrapp = styled.div`
  height: 80px;
`;
